import { useMemo } from 'react';
import ApopheniaLogger from 'apophenia-javascript-logger';
import Environment from 'apophenia-javascript-logger/dist/utils/Environment';

const LOGGER_API_KEYS = {
  dev: 'no key needed - logs sent to dev console only',
  test: 'zbgNpqEB3Z6I6wFkuChPOaTlNzqv4z2A3TkmcKfv',
  qa: 'FWbcphl96L5u2oyz7KlX7uCr5EsFNGO71GjQEba0',
  prod: 'vRbYIAcgY52d2d980gRH98uETovZ7jis45d0kOfL'
};

export const EVENTS = {
  SURVEY_START_SUCCESS: 'survey.start.success',
  SURVEY_COMPLETE_SUCCESS: 'survey.complete.success'
};

export const useLogger = (appId = 'wellness.magnolia-template-smartdollar') =>
  useMemo(
    () =>
      ApopheniaLogger.initialize({
        appId,
        apiKey: LOGGER_API_KEYS[Environment.get()]
      }),
    [appId]
  );
